import { render, staticRenderFns } from "./quantity.vue?vue&type=template&id=19815d24"
import script from "./quantity.vue?vue&type=script&lang=js"
export * from "./quantity.vue?vue&type=script&lang=js"
import style0 from "./quantity.vue?vue&type=style&index=0&id=19815d24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports